"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author OPt
 * @author Adam Drda
 */


var ForecastCoordinatorUpdateDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastCoordinatorUpdateDTOConverter, _DataObjectConverter_);

  function ForecastCoordinatorUpdateDTOConverter() {
    _classCallCheck(this, ForecastCoordinatorUpdateDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorUpdateDTOConverter).apply(this, arguments));
  }

  return ForecastCoordinatorUpdateDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastCoordinatorUpdateDTOConverter = ForecastCoordinatorUpdateDTOConverter;